import PaintProcurementInventoryWorkspace from '../../placeholders/PaintProcurementInventoryWorkspace';

export default PaintProcurementInventoryWorkspace;
